export class DlsgPolicyConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pathPrefixes",
            "baseName": "pathPrefixes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "migrationDelayHours",
            "baseName": "migrationDelayHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "isTruncateData",
            "baseName": "isTruncateData",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DlsgPolicyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
